<div class="container-informations">
  <div class="flex">
    <span class="small-padding-informations"><b>Nombre de participants:</b></span>
    <kendo-dropdownlist
      [data]="numberOfparticipant"
      (selectionChange)="clientTypeChange($event)"
      class="selection-form-individual-company"
    >
    </kendo-dropdownlist>
  </div>
  <div class="full-size align-right">
    <button kendoButton class="colored-text small-margin" [disabled]="!checkNumebr" (click)="goToNextStep()">
      Suivant
    </button>
  </div>
</div>
